import PropTypes from 'prop-types';
import React from 'react';

const Input = ({ ariaLabel, label, id, max, min, type, className, placeholder, name, readOnly, value, onChange }) => (
  <div>
    {label && <label htmlFor={id} className="form-label">{label}</label>}
    <input
      aria-label={ariaLabel}
      type={type}
      className= {className}
      id={id}
      max={max}
      min={min}
      name={name}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </div>
);

Input.propTypes = {
  ariaLabel: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired
};

Input.defaultProps = {
  type: 'text'
};

export default Input;
